import { Link, TableCell } from '@amzn/meridian';
import type { UsersPermissionTableRowUserAliasCellFragment } from 'generated/graphql';
import type { FC } from 'react';

export type UsersPermissionTableNameCellProps = {
  user: UsersPermissionTableRowUserAliasCellFragment;
};

export const UsersPermissionTableAliasCell: FC<UsersPermissionTableNameCellProps> = ({ user }) => {
  const phoneToolLink = `https://phonetool.amazon.com/users/${user.alias.toLowerCase()}`;
  return (
    <TableCell>
      <Link href={phoneToolLink} target="_blank" type="secondary">
        {user.alias.toLowerCase()}
      </Link>
    </TableCell>
  );
};
